import { ActionTree } from 'vuex';
import { IState, STEPS_MAX } from './state';
import { propOr } from 'ramda';
import { IStore } from '../index';
import * as api from '@lib/guidedbookingrequest/api';
import * as analytics from '@lib/guidedbookingrequest/analytics';

const LABEL_TRACKING_INQUIRY_FINISHED = 'Anfrage abgeschlossen';
const LABEL_TRACKING_REQUEST_INQUIRY_NOW = 'Jetzt Angebote Anfordern!';

export default {
    init({ commit, getters, state }, { country, stepHeadlines, travelThemes }) {
        commit('setCountry', country);
        commit('setStepHeadlines', stepHeadlines);
        commit('setTravelThemes', travelThemes);

        analytics.logStep(state.currentStep.toString(), getters.currentStepHeadline);
    },
    cardClicked ({ commit, dispatch, getters }, cardTitle: string) {
        commit('addTheme', {
            [getters.currentStepHeadline]: cardTitle
        });

        setTimeout(() => {
            dispatch('stepUp', { cardTitle });
        }, 100);
    },
    stepUp({ state, commit, getters }, payload) {
        const { currentStep } = state;

        let cardTitle = propOr<any, undefined, string>(payload, 'cardTitle', undefined);
        if (typeof cardTitle === 'undefined' && currentStep === 6) {
            cardTitle = LABEL_TRACKING_REQUEST_INQUIRY_NOW;
        }
        analytics.logClick(cardTitle);

        const commitAndLogStepUp = () => {
            commit('currentStepUp');

            if (currentStep >= 7) {
                analytics.logStep(currentStep.toString(), LABEL_TRACKING_INQUIRY_FINISHED);
            } else {
                analytics.logStep(currentStep.toString(), getters.currentStepHeadline);
            }
        };

        if (currentStep === (STEPS_MAX - 2)) {
            commit('setIsLoading', true);
            setTimeout(() => {
                commitAndLogStepUp();
                commit('setIsLoading', false);
            }, 4000);
        } else {
            commitAndLogStepUp();
        }
    },
    touchAllInputs({ state, commit }) {
        const { userForm } = state;

        Object.entries(userForm)
            .forEach(([key, value]) =>
                commit('setFormValue', {
                    key,
                    value: propOr(value, 'value', value)
                })
            );
    },
    async submit({ state, commit, getters, dispatch }) {
        if (!getters.validForm) {
            dispatch('touchAllInputs');
            return;
        }

        commit('setIsFormSending', true);

        const { themes, userForm, country } = state;
        const form = Object.entries(userForm).reduce((acc, [key, value]) => {
            return { ...acc, [key]: propOr(value, 'value', value) };
        }, {});

        const { valid } = await api.validate({ themes, form, country });
        if (!valid) {
            commit('setIsFormSending', false);
            return;
        }

        await api.submit({ themes, form, country });
        commit('setIsFormSending', false);

        dispatch('stepUp');
    }
} as ActionTree<IState, IStore>
